<template>
  <article class="message w-11/12 md:w-4/12"  v-if="isVisible">
    <div role="alert">
      <div class="text-white font-bold rounded-t px-4 py-2 flex justify-between" 
      :class="{'bg-red-500' : type=='is-danger' , 'bg-green-500': type=='is-success'}"
      >
        <p>{{ title }}</p>
        <button class="text-white focus:outline-none" aria-label="close" @click="isVisible = false">
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="border border-t-0  rounded-b  px-4 py-3 " 
      :class="{'border-red-400 bg-red-100 text-red-700' : type=='is-danger' , 'border-green-400 bg-green-100 text-green-700': type=='is-success'}">
        <slot></slot>
      </div>
    </div>
  </article>
</template>

<script>
  export default {
    name: 'message',
    props:['title'  , 'type'],

    data(){
      return{
        isVisible: false
      };
    },
    created(){
      let da = this;
      document.addEventListener("DOMContentLoaded", (event) => {
        setTimeout(function(){          
          da.isVisible = true;
        }, 1000);
      }); 
    },
  }
</script>
<style type="text/css">
.message {
  position: fixed;
  z-index: 41;
  left: 0;
  right: 0;
  top:0;
  margin-left: auto;
  margin-right: auto;
  animation:animatetop 2s;
}
.message .delete::before, .message .delete::after{
  background-color: #fff;
}

@keyframes animatetop{
  from{transform: translateY(-100%);;opacity:0} 
  to{transform: translateY(0%);;opacity:1}
}

</style>




// WEBPACK FOOTER //
// resources/assets/js/front/components/messages.vue